import type { LineaCanasta } from '@/lib/PropuestaEnConstruccionContext';
import type { VencimientoDetalle } from '@adelante/shared';

/**
 * Arma una línea de propuesta a partir de una factura de Vencimientos.
 * El monto a pagar queda en la moneda original de la factura (no en LCY,
 * como pasaba antes) — para una factura en USD, remainingAmount ya está
 * en dólares; remainingAmtLCY es su equivalente en colones. Para facturas
 * en CRC ambos valores son iguales.
 */
export function lineaDesdeFactura(f: VencimientoDetalle): LineaCanasta {
  const montoMaximo = f.remainingAmount ?? f.remainingAmtLCY ?? 0;
  const montoLCY = f.remainingAmtLCY ?? 0;
  const tasaImplicita = montoMaximo !== 0 ? montoLCY / montoMaximo : 1;
  return {
    entryNo: f.entryNo,
    vendorCode: f.vendorCode,
    vendorName: f.vendorName,
    montoAPagar: montoMaximo,
    montoAPagarLCY: montoLCY,
    currencyCode: f.currencyCode,
    tasaImplicita,
    montoMaximo,
    cuentaBancoOrigen: null,
  };
}
